"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomColorInput = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var Declarative_1 = require("../../utils/Declarative");
var HexColorInputWidget_1 = require("./HexColorInputWidget");
exports.CustomColorInput = React.forwardRef(function (props, ref) {
    return React.createElement("div", { "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'CustomColorInput'), ref: ref },
        React.createElement(HexColorInputWidget_1.HexColorInput, { color: props.color, label: Localize_1.Messages.customColor(), onConfirm: props.onColorSelected, testId: props.testId }));
});
exports.CustomColorInput.displayName = 'CustomColorInput';
//# sourceMappingURL=CustomColorInputWidget.js.map